/**
 * @module types/settings/fieldSetting
 * @description 表格维度 URL 格式配置（存储字段名 `field_setting`）
 *
 * key 格式: `${table_code}_${column_name}`（与 UrlSetting 写入规则一致）
 */

/** 维度字段展示格式 */
export enum FieldShowType {
  Original = 'original',
  Url = 'url',
}

export interface IFieldSettingItem {
  column_name: string;
  table_id: string;
  table_code: string;
  format: FieldShowType;
  column_role: number;
}

export type IFieldSetting = Record<string, IFieldSettingItem>;

/**
 * 空 field_setting 的模块级默认引用
 *
 * @stable 须与 STRUCTURED_SETTING_DEFAULTS.field_setting 为同一引用语义
 */
export const FIELD_SETTING_DEFAULT: IFieldSetting = Object.freeze(
  {},
) as IFieldSetting;
